import React from 'react';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { IDENTITY_PROVIDERS } from '@24i/nxg-core-utils/src/constants';
import OpenIDProvider from '../providers/openID';

const useViewModel = (props) => {
    const identityProvider = useFeature('identityProvider');
    let RenderComponent: React.FC | null = null;

    if (!identityProvider?.enabled) return { ...props, RenderComponent };

    switch (identityProvider?.provider) {
        case IDENTITY_PROVIDERS.FLOWID:
        case IDENTITY_PROVIDERS.FLOWID_V2:
        case IDENTITY_PROVIDERS.OIDC:
            RenderComponent = OpenIDProvider;
            break;
        default:
    }

    return { ...props, RenderComponent };
};

export { useViewModel };
